import _regeneratorRuntime from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator"; //@ts-check

import Utils from '../../../../../utils';
/**
 * @param {import("../types").EcrionFormState} state
 * @param {string} contactId
 * @param {any} runParameters
 */

var formContextLoader =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(state, contactId, runParameters, dispatch) {
    var environmentVars, synchronizationId, uaid, embed, user, contact, account, subscriptions, permissions, userVars, contactVars, accountVars;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // all run parameters are added as environment vars
            environmentVars = _objectSpread({}, runParameters);
            _context.prev = 1;
            synchronizationId = runParameters['ContactId'] || contactId;
            uaid = runParameters['UAID'];
            embed = runParameters['embed'] === 'true';
            _context.next = 7;
            return loadCurrentUser(uaid, embed);

          case 7:
            user = _context.sent;
            _context.next = 10;
            return loadContact(synchronizationId, uaid);

          case 10:
            contact = _context.sent;
            _context.next = 13;
            return loadAccount(contact);

          case 13:
            account = _context.sent;
            _context.next = 16;
            return loadSubscriptions(state);

          case 16:
            subscriptions = _context.sent;
            permissions = loadUserPermissions(user);
            userVars = getEnvironmentVarsFromUser(user);
            contactVars = getEnvironmentVarsFromContact(contact);
            accountVars = getEnvironmentVarsFromAccount(account);
            environmentVars = Utils.deepMerge(environmentVars, userVars);
            environmentVars = Utils.deepMerge(environmentVars, contactVars);
            environmentVars = Utils.deepMerge(environmentVars, accountVars);
            dispatch({
              type: 'FORM_CONTEXT_LOADED',
              payload: {
                environmentVars: environmentVars,
                subscriptions: subscriptions,
                permissions: permissions
              }
            });
            _context.next = 30;
            break;

          case 27:
            _context.prev = 27;
            _context.t0 = _context["catch"](1);
            dispatch({
              type: 'FORM_CONTEXT_LOADED',
              payload: {
                environmentVars: environmentVars
              }
            });

          case 30:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 27]]);
  }));

  return function formContextLoader(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var loadCurrentUser =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(uaid, embed) {
    var userName;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!uaid) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", null);

          case 2:
            if (!embed) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", null);

          case 4:
            userName = localStorage.getItem('ECR.EOS.UserName');

            if (userName) {
              _context2.next = 7;
              break;
            }

            return _context2.abrupt("return", null);

          case 7:
            _context2.next = 9;
            return Utils.request({
              url: '/backend/users',
              query: {
                userName: userName
              }
            });

          case 9:
            return _context2.abrupt("return", _context2.sent);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function loadCurrentUser(_x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

var loadContact =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(synchronizationId, uaid) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!synchronizationId) {
              _context3.next = 4;
              break;
            }

            _context3.next = 3;
            return Utils.request({
              url: '/backend/contacts',
              query: {
                synchronizationId: synchronizationId
              }
            });

          case 3:
            return _context3.abrupt("return", _context3.sent);

          case 4:
            if (!uaid) {
              _context3.next = 8;
              break;
            }

            _context3.next = 7;
            return Utils.request({
              url: '/backend/contacts',
              query: {
                id: uaid,
                byPortalAccount: true
              }
            });

          case 7:
            return _context3.abrupt("return", _context3.sent);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function loadContact(_x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}();

var loadAccount =
/*#__PURE__*/
function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(contact) {
    var accountId;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(!contact || !contact.ParentAccountIds)) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return");

          case 2:
            if (!(contact.ParentAccountIds.length < 1)) {
              _context4.next = 4;
              break;
            }

            return _context4.abrupt("return");

          case 4:
            accountId = contact.ParentAccountIds[0];
            _context4.next = 7;
            return Utils.request({
              url: '/backend/accounts',
              query: {
                id: accountId
              }
            });

          case 7:
            return _context4.abrupt("return", _context4.sent);

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function loadAccount(_x9) {
    return _ref4.apply(this, arguments);
  };
}();
/**
 * @param {import('../types').EcrionFormState} state
 * @returns {Promise<Array<import('./types').Subscription>>} A list of available subscriptions
 */


var loadSubscriptions =
/*#__PURE__*/
function () {
  var _ref5 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(state) {
    var subscriptionFieldId;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(!state || !state.fields)) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt("return", Promise.resolve(null));

          case 2:
            subscriptionFieldId = Object.keys(state.fields).find(function (fieldId) {
              return state.fields[fieldId].type === 'subscriptions';
            });

            if (subscriptionFieldId) {
              _context5.next = 5;
              break;
            }

            return _context5.abrupt("return", Promise.resolve(null));

          case 5:
            _context5.next = 7;
            return Utils.request({
              url: '/backend/subscriptions',
              query: {
                AllSubscriptions: true
              }
            }).then(function (subscriptions) {
              return subscriptions.map(function (subscription) {
                return {
                  id: subscription.Subscription.Id,
                  name: subscription.Subscription.Name,
                  description: subscription.Subscription.Description,
                  defaultValue: subscription.DefaultValue
                };
              });
            });

          case 7:
            return _context5.abrupt("return", _context5.sent);

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function loadSubscriptions(_x10) {
    return _ref5.apply(this, arguments);
  };
}();
/**
 * @param {any} user
 * @returns {Array<string>} A list of available permissions
 */


var loadUserPermissions = function loadUserPermissions(user) {
  var permissions = []; // no user, so no permissions necessary

  if (!user) return permissions;
  permissions.push('U' + user.UserName);

  for (var i = 0; i != user.Groups.length; ++i) {
    permissions.push('G' + user.Groups[i].Name);
  }

  return permissions;
};
/**
 * @param {any} user
 * @return {{ [name: string]: any }}
 */


var getEnvironmentVarsFromUser = function getEnvironmentVarsFromUser(user) {
  var environmentVars = {};
  if (!user) return environmentVars;
  environmentVars['Username'] = user.DisplayName;
  environmentVars['Email'] = user.Email;
  environmentVars['AccountId'] = localStorage.getItem('ECR.EOS.UserName');
  return environmentVars;
};
/**
 * @param {any} contact
 * @return {{ [name: string]: any }}
 */


var getEnvironmentVarsFromContact = function getEnvironmentVarsFromContact(contact) {
  var environmentVars = {};
  if (!contact) return environmentVars;
  environmentVars['Contact.Id'] = contact.Id;
  environmentVars['Contact.UAID'] = contact.UAID;
  environmentVars['Contact.SynchronizationId'] = contact.SynchronizationId;
  environmentVars['ContactId'] = contact.SynchronizationId; //shorthand

  if (contact.ParentAccountIds.length > 0) environmentVars['Contact.ParentAccountId'] = contact.ParentAccountIds[0];
  environmentVars['Contact.LastModifiedUTC'] = contact.LastModifiedUTC;
  environmentVars['Contact.IsDeleted'] = contact.IsDeleted;
  environmentVars['Contact.ActivityId'] = contact.ActivityId;

  for (var i = 0; i != contact.Properties.length; ++i) {
    var name = 'Contact.';
    var uiName = name + contact.Properties[i].Name.replace(/[-_\s]/g, '');
    var realName = name + contact.Properties[i].Name;
    environmentVars[uiName] = contact.Properties[i].Value;
    environmentVars[realName] = contact.Properties[i].Value;
  }

  return environmentVars;
};
/**
 * @param {any} account
 * @return {{ [name: string]: any }}
 */


var getEnvironmentVarsFromAccount = function getEnvironmentVarsFromAccount(account) {
  var environmentVars = {};
  if (!account) return environmentVars;
  environmentVars['Account.Id'] = account.Id;
  environmentVars['Account.AccountType'] = account.AccountType;
  environmentVars['Account.ParentAccountId'] = account.ParentAccountId;
  environmentVars['Account.SynchronizationId'] = account.SynchronizationId;
  environmentVars['Account.LastModifiedUTC'] = account.LastModifiedUTC;
  environmentVars['Account.IsDeleted'] = account.IsDeleted;
  environmentVars['Account.ActivityId'] = account.ActivityId;
  environmentVars['Account.ActivityId'] = account.ActivityId;

  for (var i = 0; i != account.Properties.length; ++i) {
    var name = 'Account.';
    var uiName = name + account.Properties[i].Name.replace(/[-_\s]/g, '');
    var realName = name + account.Properties[i].Name;
    environmentVars[uiName] = account.Properties[i].Value;
    environmentVars[realName] = account.Properties[i].Value;
  }

  return environmentVars;
};

export default formContextLoader;